module.exports = __webpack_public_path__ + "img/cafe-glocksee-mobile.d5f77135.png";